import React from 'react'
import { ReactTyped } from "react-typed";

function HomeTopBar() {
    return (
        <header className="hero-bg text-white">
            <div className="container mx-auto px-4 py-10 text-center">
                <div className="text-md font-bold tracking-widest text-secondary uppercase">
                    <span className="text-white">🔥</span>Click. Buy. Delivered. <span className="text-white">🔥</span>
                </div>
                <h1 className="text-lg md:text-3xl lg:text-6xl font-black mt-4">
                    <ReactTyped
                        strings={['Confidence', 'Quality', 'Safety', 'Authenticity', 'Satisfaction']}
                        typeSpeed={120}
                        backSpeed={70}
                        showCursor={true}
                        cursorChar="|"
                        loop={true}
                        className="text-secondary" 
                        
                    />
                    {' in Every Purchase'}
                </h1>
                <div className="mt-4 mx-auto w-20 h-1.5 bg-white rounded-full"></div>
            </div>

        </header>
    )
}

export default HomeTopBar